var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"flex-1",attrs:{"src":"https://tracker2.bitrix24.site/pomoshch/"}})}
var staticRenderFns = []

export { render, staticRenderFns }